webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(310);
	
	var _elementUi = __webpack_require__(285);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuefire = __webpack_require__(350);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	var _vueRouter = __webpack_require__(349);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueDataTables = __webpack_require__(328);
	
	var _vueDataTables2 = _interopRequireDefault(_vueDataTables);
	
	var _store = __webpack_require__(53);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _helpers = __webpack_require__(7);
	
	var _App = __webpack_require__(329);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Login = __webpack_require__(332);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Reset = __webpack_require__(336);
	
	var _Reset2 = _interopRequireDefault(_Reset);
	
	var _Confirm = __webpack_require__(330);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Users = __webpack_require__(338);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _User = __webpack_require__(337);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Projects = __webpack_require__(335);
	
	var _Projects2 = _interopRequireDefault(_Projects);
	
	var _Project = __webpack_require__(334);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _NotFound = __webpack_require__(333);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuefire2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_elementUi2.default);
	_vue2.default.use(_vueDataTables2.default);
	
	function loginRequired(to, from, next) {
	  if (_helpers.authService.authenticated()) {
	    next();
	  } else {
	    router.push('/');
	  }
	}
	
	var router = new _vueRouter2.default({
	  routes: [{ path: '/', components: { default: _Projects2.default, entry: _Login2.default } }, { path: '/reset', components: { default: _Projects2.default, entry: _Reset2.default } }, { path: '/confirm-password', components: { default: _Projects2.default, entry: _Confirm2.default } }, { path: '/users', component: _Users2.default, beforeEnter: loginRequired }, { path: '/users/:id', component: _User2.default, beforeEnter: loginRequired }, { path: '/projects', component: _Projects2.default, beforeEnter: loginRequired }, { path: '/projects/:id', component: _Project2.default, beforeEnter: loginRequired }, { path: '*', component: _NotFound2.default }],
	  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
	    next(function (vm) {
	      vm.activeLink = to.path;
	    });
	  },
	  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
	    this.activeLink = to.path;
	    next();
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  store: _store2.default,
	  router: router,
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authService = exports.db = undefined;
	
	var _promise = __webpack_require__(235);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _firebase = __webpack_require__(313);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _store = __webpack_require__(53);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  apiKey: "AIzaSyCg2X1ATSwIi9uZ4JOsFRq7l3gQzizg1FE",
	  authDomain: "marcatest001.firebaseapp.com",
	  databaseURL: "https://marcatest001.firebaseio.com",
	  projectId: "marcatest001",
	  storageBucket: "marcatest001.appspot.com",
	  messagingSenderId: "906655944588"
	};
	
	var firebaseApp = _firebase2.default.initializeApp(config);
	var db = firebaseApp.database();
	
	var initializeAuth = new _promise2.default(function (resolve) {
	  _firebase2.default.auth().onAuthStateChanged(function (user) {
	    authService.setUser(user);
	    resolve(user);
	  });
	});
	
	var authService = {
	
	  user: null,
	
	  authenticated: function authenticated() {
	    return initializeAuth.then(function (user) {
	      return user;
	    });
	  },
	  setUser: function setUser(user) {
	    if (user) {
	      _store2.default.dispatch('setUser', user);
	    } else {
	      _store2.default.dispatch('setUser', null);
	    }
	    this.user = user;
	  },
	  userCreate: function userCreate(email, password) {
	    return _firebase2.default.auth().createUserWithEmailAndPassword(email, password).then(function () {
	      var user = _firebase2.default.auth().currentUser;
	      if (user) {
	        db.ref('users/' + user.uid).set({
	          email: user.email,
	          isAdmin: false
	        });
	      } else {
	        console.log('There is no current user');
	      }
	    }).catch(function (error) {
	      window.alert(error.message);
	    }).then(function () {
	      return _firebase2.default.auth().signOut().then(function () {
	        window.location.href = '/';
	      });
	    });
	  },
	  userDelete: function userDelete(uid) {
	    db.ref('users/' + uid).remove();
	    window.location.href = '/#/users';
	  },
	  login: function login(email, password) {
	    return _firebase2.default.auth().signInWithEmailAndPassword(email, password).then(function () {}).catch(function (error) {
	      window.alert(error.message + ' Contact platform@marcastudio.com for more details.');
	    });
	  },
	  logout: function logout() {
	    return _firebase2.default.auth().signOut().then(function () {
	      window.location.href = '/';
	    });
	  },
	  reset: function reset(email) {
	    return _firebase2.default.auth().sendPasswordResetEmail(email).then(function () {
	      window.alert('Password Reset Email Sent!');
	      window.location.href = '/';
	    }).catch(function (error) {
	      window.alert(error.message + ' Contact platform@marcastudio.com for more details.');
	    });
	  },
	  setNewPassword: function setNewPassword() {
	    var urlParams = new URLSearchParams(window.location.search);
	    console.log(urlParams.get('mode'));
	    console.log(urlParams.get('oobCode'));
	    console.log(urlParams.get('apiKey'));
	  }
	};
	
	exports.db = db;
	exports.authService = authService;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(195);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  currentUser: {},
	  userMeta: {}
	};
	
	var mutations = {
	  SET_USER: function SET_USER(state, user) {
	    if (user) {
	      state.currentUser = user;
	      _helpers.db.ref('users/' + user.uid).once('value').then(function (s) {
	        state.userMeta = s.val();
	      }, function (error) {
	        console.error(error);
	      });
	    }
	  }
	};
	
	var actions = {
	  setUser: function setUser(_ref, user) {
	    var commit = _ref.commit;
	
	    commit('SET_USER', user);
	  }
	};
	
	var store = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations,
	  actions: actions
	});
	
	exports.default = store;

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _json2csv = __webpack_require__(318);
	
	var _json2csv2 = _interopRequireDefault(_json2csv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (data, fields, fieldNames, fileName) {
	  try {
	    var result = (0, _json2csv2.default)({
	      data: data,
	      fields: fields,
	      fieldNames: fieldNames
	    });
	    var encodedUri = encodeURI(result);
	    var link = document.createElement('a');
	    link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodedUri);
	    link.setAttribute('download', (fileName || 'file') + '.csv');
	    document.body.appendChild(link);
	    link.click();
	    document.body.removeChild(link);
	  } catch (err) {
	    console.error(err);
	  }
	};

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(331);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	
	  data: function data() {
	    return {
	      auth: _helpers.authService
	    };
	  },
	
	
	  components: {
	    AppHeader: _Header2.default
	  }
	};

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(7);
	
	exports.default = {
	  name: 'confirm',
	
	  data: function data() {
	    return {
	      dataReady: false,
	      auth: _helpers.authService
	    };
	  },
	
	
	  components: {},
	
	  created: function created() {
	    this.auth.setNewPassword();
	    this.dataReady = true;
	  }
	};

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(7);
	
	var _vuex = __webpack_require__(195);
	
	exports.default = {
	  name: 'header',
	
	  data: function data() {
	    return {
	      activeIndex: '1',
	      activeIndex2: '2',
	      auth: _helpers.authService
	    };
	  },
	
	  computed: (0, _vuex.mapState)(['currentUser', 'userMeta']),
	  methods: {
	    logOut: function logOut() {
	      this.auth.logout();
	    }
	  }
	
	};

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(7);
	
	exports.default = {
	  data: function data() {
	    return {
	      labelPosition: 'top',
	      auth: _helpers.authService,
	      loginForm: {
	        email: '',
	        pass: ''
	      },
	      resetForm: {
	        email: ''
	      },
	      rules: {
	        email: [{ required: true, message: 'Please enter you email address', trigger: 'blur' }, { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }],
	        pass: [{ required: true, message: 'Please enter your password', trigger: 'blur' }, { min: 6, message: 'Your password is too short!' }]
	      }
	    };
	  },
	
	  methods: {
	    submitForm: function submitForm(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var email = _this.loginForm.email;
	          var pass = _this.loginForm.pass;
	          _this.auth.login(email, pass);
	          _this.loginForm.email = '';
	          _this.loginForm.pass = '';
	        } else {
	          console.log('There was an error!');
	          return false;
	        }
	      });
	    }
	  }
	};

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(234);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _CsvExport = __webpack_require__(221);
	
	var _CsvExport2 = _interopRequireDefault(_CsvExport);
	
	var _PapaParse = __webpack_require__(197);
	
	var _PapaParse2 = _interopRequireDefault(_PapaParse);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _slugify = __webpack_require__(192);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _en = __webpack_require__(288);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _locale = __webpack_require__(33);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_locale2.default.use(_en2.default);
	var projectRef;
	exports.default = {
	  name: 'project',
	  data: function data() {
	    return {
	      dataReady: false,
	      loading: true,
	      hideEmptyTables: false,
	      auth: _helpers.authService,
	      uid: '',
	      options: [{
	        value: 'Available',
	        label: 'Available'
	      }, {
	        value: 'Held',
	        label: 'Held'
	      }, {
	        value: 'Sold',
	        label: 'Sold'
	      }, {
	        value: 'Future',
	        label: 'Future'
	      }],
	      value: '',
	      formInline: {
	        user: '',
	        unitFile: ''
	      },
	
	      dialogFormVisible: false,
	      deleteFormVisible: false,
	      labelPosition: 'top',
	      form: {
	        id: '',
	        unitnum: '',
	        floor: '',
	        unit: '',
	        size: '',
	        size2: '',
	        plan: '',
	        type: '',
	        file: '',
	        plate: '',
	        price: '',
	        status: '',
	        view: ''
	      },
	      tprops: {
	        height: 'auto',
	        slotScope: 'prop',
	        rowStyle: function rowStyle(row, rowIndex) {
	          return {};
	        }
	      },
	      tableProps: {},
	      tableColumns: [],
	      tableHeader: [],
	      tableData: [],
	      ordering: [],
	      input: '',
	      unitData: []
	    };
	  },
	  created: function created() {
	    var vm = this;
	    this.makeTableHeader();
	    this.$bindAsObject('user', _helpers.db.ref('users').child(this.auth.user.uid));
	    projectRef = _helpers.db.ref(this.$route.path);
	    this.$bindAsObject('project', projectRef);
	    this.dataReady = true;
	    this.loading = false;
	
	    projectRef.child('units').on('value', function (snapshot) {
	      vm.unitData = snapshot.val();
	      vm.makeTable();
	    });
	
	    projectRef.child('ordering').on('value', function (snapshot) {
	      var orderingData = snapshot.val();
	      vm.input = orderingData;
	      vm.ordering = orderingData.split(',');
	      vm.makeTable();
	    });
	  },
	
	
	  methods: {
	    makeTable: function makeTable() {
	      var vm = this;
	
	      if (vm.unitData.length === 0) return;
	
	      var columnHeaders = vm.unitData[0];
	      vm.tableColumns = vm.sortByOtherArray((0, _keys2.default)(columnHeaders), vm.ordering).map(function (val, ind, len) {
	        return {
	          slot: 'item',
	          val: val,
	          label: val,
	          fixed: val === 'unit',
	          width: val === 'unit' ? 75 : 200,
	          showOverflowTooltip: false
	        };
	      });
	      vm.makeTableHeader();
	
	      function sortObject(obj) {
	        return vm.sortByOtherArray((0, _keys2.default)(columnHeaders), vm.ordering).reduce(function (a, v) {
	          a[v] = obj[v];
	          return a;
	        }, {});
	      }
	
	      vm.tableData = vm.unitData.map(function (value, index, self) {
	        return sortObject(value);
	      });
	    },
	    makeTableHeader: function makeTableHeader() {
	      this.tableHeader = this.tableColumns.map(function (_) {
	        return _.val;
	      });
	    },
	    deleteProject: function deleteProject() {
	      this.$firebaseRefs.project.remove();
	      this.deleteFormVisible = false;
	      this.$router.push('/projects');
	    },
	    prettyDate: function prettyDate(date) {
	      return (0, _moment2.default)(date).format('MMMM Do YYYY, h:mm:ss a');
	    },
	    setDate: function setDate() {
	      var timeStamp = Date.now();
	      this.$firebaseRefs.project.child('edited').set(timeStamp);
	      this.$firebaseRefs.project.child('mostRecent').set(-Math.abs(timeStamp));
	    },
	    updateName: function updateName() {
	      var newName = this.project.name;
	      this.$firebaseRefs.project.child('name').set(newName);
	      this.$firebaseRefs.project.child('slug').set((0, _slugify2.default)(newName.toLowerCase()));
	      this.setDate();
	    },
	    updateFile: function updateFile(e) {
	      var vm = this;
	      _PapaParse2.default.parse(e.target.files[0], {
	        header: true,
	        complete: function complete(results, file) {
	          vm.$firebaseRefs.project.child('units').set(results.data);
	          vm.setDate();
	        }
	      });
	      e.target.value = '';
	    },
	    handlePreview: function handlePreview(file, fileList) {
	      console.log(file, 'handle preview');
	    },
	    handleRemove: function handleRemove(file, fileList) {
	      console.log(file, fileList);
	    },
	    handleFilterDataChange: function handleFilterDataChange(filteredData) {
	      this.filteredData = filteredData;
	    },
	    openDatabase: function openDatabase() {
	      window.open('https:///marcatest001.firebaseio.com' + this.$route.path + '/units.json', '_blank');
	    },
	    updateUnits: function updateUnits() {
	      this.$firebaseRefs.project.child('units').set(this.project.units);
	      this.setDate();
	      this.dialogFormVisible = false;
	    },
	    updateOrdering: function updateOrdering() {
	      this.$firebaseRefs.project.child('ordering').set(this.input);
	    },
	    cancelUpdateUnits: function cancelUpdateUnits() {
	      projectRef = _helpers.db.ref(this.$route.path);
	      this.$bindAsObject('project', projectRef);
	      this.dialogFormVisible = false;
	    },
	    getSearchDef: function getSearchDef() {
	      return {
	        show: true,
	        placeholder: 'Search by Keyword',
	        props: this.tableHeader
	      };
	    },
	    getPaginationDef: function getPaginationDef() {
	      return {
	        layout: 'total, prev, pager, next, jumper, sizes',
	        pageSize: 300,
	        pageSizes: [20, 50, 100, 150, 200, 300],
	        currentPage: 1
	      };
	    },
	    getExportActionsDef: function getExportActionsDef() {
	      var columns = this.tableHeader;
	      var columnNames = this.tableHeader;
	      var timeStamp = (0, _moment2.default)(Date.now()).format();
	      (0, _CsvExport2.default)(this.project.units, columns, columnNames, this.project.slug + '_' + timeStamp);
	    },
	    sortByOtherArray: function sortByOtherArray(itemArray, itemOrder) {
	      function unique(arr, comparator) {
	        var uniqueArr = [];
	        for (var i in arr) {
	          var found = false;
	          for (var j in uniqueArr) {
	            if (comparator instanceof Function) {
	              if (comparator(null, arr[i], uniqueArr[j])) {
	                found = true;
	                break;
	              }
	            } else {
	              if (arr[i] === uniqueArr[j]) {
	                found = true;
	                break;
	              }
	            }
	          }
	          if (!found) {
	            uniqueArr.push(arr[i]);
	          }
	        }
	        return uniqueArr;
	      }
	
	      var result = [];
	
	      itemOrder.forEach(function (key) {
	        var found = false;
	        itemArray = itemArray.filter(function (item) {
	          if (!found && item === key) {
	            result.push(item);
	            found = true;
	            return false;
	          } else {
	            return true;
	          }
	        });
	      });
	
	      result = unique(result.concat(itemArray), function (a, b) {
	        return a === b;
	      });
	
	      return result;
	    },
	    sortColumns: function sortColumns(a, b) {
	      console.log('hello?');
	      return a < b;
	    }
	  }
	};

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(7);
	
	var _slugify = __webpack_require__(192);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectsRef = _helpers.db.ref('projects');
	var usersRef = _helpers.db.ref('users');
	
	exports.default = {
	  name: 'projects',
	  firebase: {
	    projects: projectsRef.orderByChild('mostRecent')
	  },
	  data: function data() {
	    return {
	      admin: true,
	      auth: _helpers.authService,
	      labelPosition: 'top',
	      userInline: {
	        displayName: '',
	        email: '',
	        password: ''
	      },
	      rules: {
	        email: [{ required: true, message: 'Please enter you email address', trigger: 'blur' }, { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }],
	        name: [{ required: true, message: 'Project Name required', trigger: 'blur' }]
	      },
	      newProject: {
	        created: null,
	        edited: null,
	        slug: '',
	        name: '',
	        units: '',
	        users: ''
	      }
	    };
	  },
	
	  methods: {
	    addproject: function addproject(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var timeStamp = Date.now();
	          _this.newProject.mostRecent = -Math.abs(timeStamp);
	          _this.newProject.created = timeStamp;
	          _this.newProject.edited = timeStamp;
	          _this.newProject.slug = (0, _slugify2.default)(_this.newProject.name.toLowerCase());
	          projectsRef.push(_this.newProject);
	          _this.newProject.created = '';
	          _this.newProject.edited = '';
	          _this.newProject.slug = '';
	          _this.newProject.name = '';
	          _this.newProject.units = '';
	        } else {
	          console.log('Error with add project!');
	          return false;
	        }
	      });
	    },
	    prettyDate: function prettyDate(date) {
	      return (0, _moment2.default)(date).format('MMMM Do YYYY, h:mm:ss a');
	    }
	  },
	  created: function created() {
	    this.$bindAsObject('user', usersRef.child(this.auth.user.uid));
	    this.$bindAsArray('userProjects', projectsRef.orderByChild('users/' + this.auth.user.uid).equalTo(true));
	  }
	};

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(7);
	
	exports.default = {
	  data: function data() {
	    return {
	      auth: _helpers.authService,
	      labelPosition: 'top',
	      ruleForm: {
	        email: ''
	      },
	      rules: {
	        email: [{ required: true, message: 'Please enter your email address', trigger: 'blur' }, { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }]
	      }
	    };
	  },
	
	  methods: {
	    submitForm: function submitForm(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          _this.auth.reset(_this.ruleForm.email);
	        } else {
	          console.log('error submit!!');
	          return false;
	        }
	      });
	    }
	  }
	};

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(238);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userRef = void 0;
	var projectsRef = _helpers.db.ref('projects');
	
	exports.default = {
	  name: 'user',
	
	  firebase: {
	    projects: projectsRef
	  },
	
	  data: function data() {
	    return {
	      auth: _helpers.authService,
	      labelPosition: 'top',
	      deleteFormVisible: false,
	      dataReady: false
	    };
	  },
	  created: function created() {
	    userRef = _helpers.db.ref(this.$route.path);
	    this.$bindAsObject('user', userRef);
	    this.$bindAsArray('userProjects', projectsRef.orderByChild('users/' + this.auth.user.uid).equalTo(true));
	    this.dataReady = true;
	  },
	
	
	  methods: {
	    prettyDate: function prettyDate(date) {
	      return (0, _moment2.default)(date).format('MMMM Do YYYY, h:mm:ss a');
	    },
	    updateUserRole: function updateUserRole() {
	      var userRole = this.user.isAdmin;
	      this.$firebaseRefs.user.child('isAdmin').remove();
	      this.$firebaseRefs.user.child('isAdmin').set(userRole);
	    },
	    updateUserProjects: function updateUserProjects(project, uid) {
	      var ref = this.$firebaseRefs.projects.child(project['.key']).child('users/');
	      ref.once('value').then(function (snapshot) {
	        if (snapshot.child(uid).val() === null) {
	          ref.update((0, _defineProperty3.default)({}, uid, true));
	        } else {
	          ref.update((0, _defineProperty3.default)({}, uid, project.users[uid]));
	        }
	      });
	    },
	    deleteUser: function deleteUser() {
	      this.auth.userDelete(this.user['.key']);
	    }
	  }
	
	};

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(7);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectsRef = _helpers.db.ref('projects');
	var usersRef = _helpers.db.ref('users');
	exports.default = {
	  name: 'profiles',
	  firebase: {
	    projects: projectsRef,
	    users: usersRef
	  },
	  data: function data() {
	    return {
	      auth: _helpers.authService,
	      labelPosition: 'top',
	      addUserForm: {
	        email: '',
	        pass: ''
	      },
	      rules: {
	        email: [{ required: true, message: 'Please enter your email address', trigger: 'blur' }, { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }],
	        pass: [{ required: true, message: 'Please enter your password', trigger: 'blur' }, { min: 6, message: 'Your password is too short!' }]
	      }
	    };
	  },
	
	  methods: {
	    prettyDate: function prettyDate(date) {
	      return (0, _moment2.default)(date).format('MMMM Do YYYY, h:mm:ss a');
	    },
	    submitForm: function submitForm(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var email = _this.addUserForm.email;
	          var pass = _this.addUserForm.pass;
	          _this.auth.userCreate(email, pass);
	          _this.addUserForm.email = '';
	          _this.addUserForm.pass = '';
	        } else {
	          alert('There was an error!');
	          return false;
	        }
	      });
	    }
	  },
	  created: function created() {
	    this.$bindAsObject('user', usersRef.child(this.auth.user.uid));
	  }
	};

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 76,
		"./af.js": 76,
		"./ar": 83,
		"./ar-dz": 77,
		"./ar-dz.js": 77,
		"./ar-kw": 78,
		"./ar-kw.js": 78,
		"./ar-ly": 79,
		"./ar-ly.js": 79,
		"./ar-ma": 80,
		"./ar-ma.js": 80,
		"./ar-sa": 81,
		"./ar-sa.js": 81,
		"./ar-tn": 82,
		"./ar-tn.js": 82,
		"./ar.js": 83,
		"./az": 84,
		"./az.js": 84,
		"./be": 85,
		"./be.js": 85,
		"./bg": 86,
		"./bg.js": 86,
		"./bn": 87,
		"./bn.js": 87,
		"./bo": 88,
		"./bo.js": 88,
		"./br": 89,
		"./br.js": 89,
		"./bs": 90,
		"./bs.js": 90,
		"./ca": 91,
		"./ca.js": 91,
		"./cs": 92,
		"./cs.js": 92,
		"./cv": 93,
		"./cv.js": 93,
		"./cy": 94,
		"./cy.js": 94,
		"./da": 95,
		"./da.js": 95,
		"./de": 98,
		"./de-at": 96,
		"./de-at.js": 96,
		"./de-ch": 97,
		"./de-ch.js": 97,
		"./de.js": 98,
		"./dv": 99,
		"./dv.js": 99,
		"./el": 100,
		"./el.js": 100,
		"./en-au": 101,
		"./en-au.js": 101,
		"./en-ca": 102,
		"./en-ca.js": 102,
		"./en-gb": 103,
		"./en-gb.js": 103,
		"./en-ie": 104,
		"./en-ie.js": 104,
		"./en-nz": 105,
		"./en-nz.js": 105,
		"./eo": 106,
		"./eo.js": 106,
		"./es": 108,
		"./es-do": 107,
		"./es-do.js": 107,
		"./es.js": 108,
		"./et": 109,
		"./et.js": 109,
		"./eu": 110,
		"./eu.js": 110,
		"./fa": 111,
		"./fa.js": 111,
		"./fi": 112,
		"./fi.js": 112,
		"./fo": 113,
		"./fo.js": 113,
		"./fr": 116,
		"./fr-ca": 114,
		"./fr-ca.js": 114,
		"./fr-ch": 115,
		"./fr-ch.js": 115,
		"./fr.js": 116,
		"./fy": 117,
		"./fy.js": 117,
		"./gd": 118,
		"./gd.js": 118,
		"./gl": 119,
		"./gl.js": 119,
		"./gom-latn": 120,
		"./gom-latn.js": 120,
		"./he": 121,
		"./he.js": 121,
		"./hi": 122,
		"./hi.js": 122,
		"./hr": 123,
		"./hr.js": 123,
		"./hu": 124,
		"./hu.js": 124,
		"./hy-am": 125,
		"./hy-am.js": 125,
		"./id": 126,
		"./id.js": 126,
		"./is": 127,
		"./is.js": 127,
		"./it": 128,
		"./it.js": 128,
		"./ja": 129,
		"./ja.js": 129,
		"./jv": 130,
		"./jv.js": 130,
		"./ka": 131,
		"./ka.js": 131,
		"./kk": 132,
		"./kk.js": 132,
		"./km": 133,
		"./km.js": 133,
		"./kn": 134,
		"./kn.js": 134,
		"./ko": 135,
		"./ko.js": 135,
		"./ky": 136,
		"./ky.js": 136,
		"./lb": 137,
		"./lb.js": 137,
		"./lo": 138,
		"./lo.js": 138,
		"./lt": 139,
		"./lt.js": 139,
		"./lv": 140,
		"./lv.js": 140,
		"./me": 141,
		"./me.js": 141,
		"./mi": 142,
		"./mi.js": 142,
		"./mk": 143,
		"./mk.js": 143,
		"./ml": 144,
		"./ml.js": 144,
		"./mr": 145,
		"./mr.js": 145,
		"./ms": 147,
		"./ms-my": 146,
		"./ms-my.js": 146,
		"./ms.js": 147,
		"./my": 148,
		"./my.js": 148,
		"./nb": 149,
		"./nb.js": 149,
		"./ne": 150,
		"./ne.js": 150,
		"./nl": 152,
		"./nl-be": 151,
		"./nl-be.js": 151,
		"./nl.js": 152,
		"./nn": 153,
		"./nn.js": 153,
		"./pa-in": 154,
		"./pa-in.js": 154,
		"./pl": 155,
		"./pl.js": 155,
		"./pt": 157,
		"./pt-br": 156,
		"./pt-br.js": 156,
		"./pt.js": 157,
		"./ro": 158,
		"./ro.js": 158,
		"./ru": 159,
		"./ru.js": 159,
		"./sd": 160,
		"./sd.js": 160,
		"./se": 161,
		"./se.js": 161,
		"./si": 162,
		"./si.js": 162,
		"./sk": 163,
		"./sk.js": 163,
		"./sl": 164,
		"./sl.js": 164,
		"./sq": 165,
		"./sq.js": 165,
		"./sr": 167,
		"./sr-cyrl": 166,
		"./sr-cyrl.js": 166,
		"./sr.js": 167,
		"./ss": 168,
		"./ss.js": 168,
		"./sv": 169,
		"./sv.js": 169,
		"./sw": 170,
		"./sw.js": 170,
		"./ta": 171,
		"./ta.js": 171,
		"./te": 172,
		"./te.js": 172,
		"./tet": 173,
		"./tet.js": 173,
		"./th": 174,
		"./th.js": 174,
		"./tl-ph": 175,
		"./tl-ph.js": 175,
		"./tlh": 176,
		"./tlh.js": 176,
		"./tr": 177,
		"./tr.js": 177,
		"./tzl": 178,
		"./tzl.js": 178,
		"./tzm": 180,
		"./tzm-latn": 179,
		"./tzm-latn.js": 179,
		"./tzm.js": 180,
		"./uk": 181,
		"./uk.js": 181,
		"./ur": 182,
		"./ur.js": 182,
		"./uz": 184,
		"./uz-latn": 183,
		"./uz-latn.js": 183,
		"./uz.js": 184,
		"./vi": 185,
		"./vi.js": 185,
		"./x-pseudo": 186,
		"./x-pseudo.js": 186,
		"./yo": 187,
		"./yo.js": 187,
		"./zh-cn": 188,
		"./zh-cn.js": 188,
		"./zh-hk": 189,
		"./zh-hk.js": 189,
		"./zh-tw": 190,
		"./zh-tw.js": 190
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 324;


/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(301)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(222),
	  /* template */
	  __webpack_require__(340),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(300)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(223),
	  /* template */
	  __webpack_require__(339),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(309)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(224),
	  /* template */
	  __webpack_require__(348),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(307)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(225),
	  /* template */
	  __webpack_require__(346),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(305)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(226),
	  /* template */
	  __webpack_require__(344),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(306)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(227),
	  /* template */
	  __webpack_require__(345),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(303)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(228),
	  /* template */
	  __webpack_require__(342),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(308)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(229),
	  /* template */
	  __webpack_require__(347),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(304)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(230),
	  /* template */
	  __webpack_require__(343),
	  /* scopeId */
	  "data-v-7d42deda",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(302)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(231),
	  /* template */
	  __webpack_require__(341),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 339:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.dataReady) ? _c('div', {
	    staticClass: "container page-container"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('h1', [_vm._v("Confirm new password")])])], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('app-header'), _vm._v(" "), (_vm.auth.user == null) ? _c('div', [_c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in",
	      "appear-class": "fade"
	    }
	  }, [(_vm.auth.user == null) ? _c('router-view', {
	    attrs: {
	      "name": "entry"
	    }
	  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.auth.user !== null) ? _c('div', [_c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in",
	      "appear-class": "fade"
	    }
	  }, [(_vm.auth.user !== null) ? _c('router-view') : _vm._e()], 1)], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.user.isAdmin) ? _c('div', {
	    staticClass: "container page-container",
	    attrs: {
	      "id": "profile-form"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('h1', [_vm._v("Add a User")]), _vm._v(" "), _c('el-form', {
	    ref: "addUserForm",
	    staticClass: "ruleForm",
	    attrs: {
	      "model": _vm.addUserForm,
	      "rules": _vm.rules,
	      "label-position": _vm.labelPosition,
	      "label-width": "100px"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.addUserForm.email),
	      callback: function($$v) {
	        _vm.addUserForm.email = $$v
	      },
	      expression: "addUserForm.email"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Password",
	      "prop": "pass"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.addUserForm.pass),
	      callback: function($$v) {
	        _vm.addUserForm.pass = $$v
	      },
	      expression: "addUserForm.pass"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('el-form-item', [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.submitForm('addUserForm')
	      }
	    }
	  }, [_vm._v("Add User")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('h1', [_vm._v("Manage Users")])])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, _vm._l((_vm.users), function(user, index) {
	    return _c('el-col', {
	      key: user.email,
	      attrs: {
	        "xs": 24,
	        "sm": 24,
	        "md": 12,
	        "lg": 12
	      }
	    }, [_c('el-card', {
	      staticClass: "box-card"
	    }, [_c('div', {
	      staticClass: "text item"
	    }, [_c('span', {
	      staticClass: "user-title"
	    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "float": "right"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.$router.push('/users/' + user['.key'])
	        }
	      }
	    }, [_vm._v("Manage")]), _vm._v(" "), _c('div', {
	      staticClass: "cf"
	    }), _vm._v(" "), (user.isAdmin !== false) ? _c('span', {
	      staticClass: "edited"
	    }, [_vm._v("Admin")]) : _vm._e(), _vm._v(" "), (user.isAdmin == false) ? _c('span', {
	      staticClass: "edited"
	    }, [_vm._v("Client")]) : _vm._e()], 1)])], 1)
	  }))], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container page-container"
	  }, [_c('h1', [_vm._v("Your Projects")]), _vm._v(" "), (_vm.user.isAdmin) ? _c('div', {
	    staticClass: "add-project"
	  }, [_c('el-form', {
	    ref: "addProjectForm",
	    staticClass: "form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.newProject,
	      "rules": _vm.rules,
	      "label-position": _vm.labelPosition
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Project Name",
	      "prop": "name"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Name"
	    },
	    model: {
	      value: (_vm.newProject.name),
	      callback: function($$v) {
	        _vm.newProject.name = $$v
	      },
	      expression: "newProject.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": " "
	    }
	  }, [_c('el-button', {
	    staticClass: "btn-add",
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addproject('addProjectForm')
	      }
	    }
	  }, [_vm._v("Add  "), _c('i', {
	    staticClass: "el-icon-plus el-icon-right"
	  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin !== true) ? _c('div', [(_vm.auth.user !== null) ? _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, _vm._l((_vm.userProjects), function(project, index) {
	    return _c('el-col', {
	      key: project.name,
	      attrs: {
	        "xs": 24,
	        "sm": 24,
	        "md": 12,
	        "lg": 12
	      }
	    }, [_c('el-card', {
	      staticClass: "box-card"
	    }, [_c('div', {
	      staticClass: "text item"
	    }, [_c('span', {
	      staticClass: "project-title"
	    }, [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "float": "right"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.$router.push('/projects/' + project['.key'])
	        }
	      }
	    }, [_vm._v("Manage")]), _vm._v(" "), _c('span', {
	      staticClass: "edited"
	    }, [_vm._v("Edited: " + _vm._s(_vm.prettyDate(project.edited)))])], 1)])], 1)
	  })) : _vm._e(), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin == true) ? _c('div', [(_vm.auth.user !== null) ? _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, _vm._l((_vm.projects), function(project, index) {
	    return _c('el-col', {
	      key: project.name,
	      attrs: {
	        "xs": 24,
	        "sm": 24,
	        "md": 12,
	        "lg": 12
	      }
	    }, [_c('el-card', {
	      staticClass: "box-card"
	    }, [_c('div', {
	      staticClass: "text item"
	    }, [_c('span', {
	      staticClass: "project-title"
	    }, [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "float": "right"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.$router.push('/projects/' + project['.key'])
	        }
	      }
	    }, [_vm._v("Manage")]), _vm._v(" "), _c('span', {
	      staticClass: "edited"
	    }, [_vm._v("Edited: " + _vm._s(_vm.prettyDate(project.edited)))])], 1)])], 1)
	  })) : _vm._e(), _vm._v(" "), _c('br')], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.dataReady) ? _c('div', {
	    staticClass: "container page-container"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('h1', {
	    on: {
	      "click": function($event) {
	        _vm.deleteFormVisible = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
	    on: {
	      "change": _vm.updateUserRole
	    },
	    model: {
	      value: (_vm.user.isAdmin),
	      callback: function($$v) {
	        _vm.user.isAdmin = $$v
	      },
	      expression: "user.isAdmin"
	    }
	  }, [_vm._v(" Admin")]), _c('br'), _vm._v(" "), (_vm.user.isAdmin !== true) ? _c('div', {
	    staticClass: "project-select"
	  }, [_c('h3', [_vm._v("Projects")]), _vm._v(" "), (_vm.projects) ? _c('ul', _vm._l((_vm.projects), function(project, index) {
	    return _c('li', [_c('el-checkbox', {
	      on: {
	        "change": function($event) {
	          _vm.updateUserProjects(project, _vm.user['.key'])
	        }
	      },
	      model: {
	        value: (project.users[_vm.user['.key']]),
	        callback: function($$v) {
	          var $$exp = project.users,
	            $$idx = _vm.user['.key'];
	          if (!Array.isArray($$exp)) {
	            project.users[_vm.user['.key']] = $$v
	          } else {
	            $$exp.splice($$idx, 1, $$v)
	          }
	        },
	        expression: "project.users[user['.key']]"
	      }
	    }, [_vm._v(" " + _vm._s(project.name))])], 1)
	  })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "size": "large",
	      "icon": "arrow-left"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.$router.push('/users')
	      }
	    }
	  }, [_vm._v(" Back to Users")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "Are You Sure You Want To Delete This User?",
	      "visible": _vm.deleteFormVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.deleteFormVisible = $event
	      }
	    }
	  }, [_c('el-form', {
	    attrs: {
	      "inline": true,
	      "label-position": _vm.labelPosition
	    }
	  }, [_c('p', [_vm._v("You will also need to delete the user in the "), _c('a', {
	    staticClass: "link-out",
	    attrs: {
	      "href": "http://console.firebase.google.com",
	      "target": "_blank"
	    }
	  }, [_vm._v("Firebase console")]), _vm._v(".")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.deleteFormVisible = false
	      }
	    }
	  }, [_vm._v("No Way, Get Me Out Of Here!")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "danger"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteUser()
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "not-found"
	    }
	  }, [_c('h1', [_vm._v("Not found ... ")])])
	}]}

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.dataReady) ? _c('div', {
	    staticClass: "container page-container"
	  }, [_c('h1', {
	    staticClass: "project"
	  }, [_vm._v(_vm._s(_vm.project.name))]), _vm._v(" "), _c('p', {
	    staticClass: "edited"
	  }, [_vm._v("Edited: "), _c('span', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.prettyDate(_vm.project.edited)))]), _c('br'), _vm._v("\n  Created: "), _c('span', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.prettyDate(_vm.project.created)))])]), _vm._v(" "), (_vm.user.isAdmin) ? _c('div', {
	    staticClass: "add-project"
	  }, [_c('el-form', {
	    staticClass: "form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.formInline,
	      "label-position": _vm.labelPosition
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Edit Project Name"
	    }
	  }, [_c('el-input', {
	    on: {
	      "change": _vm.updateName
	    },
	    model: {
	      value: (_vm.project.name),
	      callback: function($$v) {
	        _vm.project.name = $$v
	      },
	      expression: "project.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Add Project Data"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "file",
	      "accept": ".csv"
	    },
	    on: {
	      "change": _vm.updateFile
	    }
	  })]), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": " "
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.getExportActionsDef()
	      }
	    }
	  }, [_vm._v("Export "), _c('i', {
	    staticClass: "el-icon-document el-icon-plus"
	  })]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.openDatabase()
	      }
	    }
	  }, [_vm._v("View JSON "), _c('i', {
	    staticClass: "el-icon-document el-icon-right"
	  })]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.hideEmptyTables = !_vm.hideEmptyTables
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.hideEmptyTables ? "Show Empty Cells" : "Hide Empty Cells"))]), _vm._v(" "), _c('el-button', {
	    staticClass: "btn-delete",
	    attrs: {
	      "type": "danger",
	      "disabled": !_vm.user.isAdmin
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteFormVisible = true
	      }
	    }
	  }, [_vm._v("Delete Project "), _c('i', {
	    staticClass: "el-icon-delete el-icon-right"
	  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return _vm._l((props.row), function(value, propertyName, index) {
	          return (propertyName !== 'unit') ? _c('div', [(_vm.hideEmptyTables && (value === undefined || value === null || value === '')) ? _c('el-row') : _c('el-row', [(value !== undefined && value !== null && value !== '') ? _c('b', [_vm._v(_vm._s(propertyName) + ":")]) : _c('b', [_c('s', [_vm._v(_vm._s(propertyName) + ":")])]), _vm._v(" "), _c('i', [_vm._v(_vm._s(value))]), _vm._v(" "), _c('hr')])], 1) : _vm._e()
	        })
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Unit",
	      "prop": "unit"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Status",
	      "prop": "status"
	    }
	  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Enter Custom Ordering",
	      "readonly": !_vm.user.isAdmin
	    },
	    model: {
	      value: (_vm.input),
	      callback: function($$v) {
	        _vm.input = $$v
	      },
	      expression: "input"
	    }
	  }, [_vm._v(_vm._s(_vm.ordering)), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": !_vm.user.isAdmin
	    },
	    on: {
	      "click": _vm.updateOrdering
	    },
	    slot: "append"
	  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "Are You Sure You Want To Delete This Project?",
	      "visible": _vm.deleteFormVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.deleteFormVisible = $event
	      }
	    }
	  }, [_c('el-form', {
	    attrs: {
	      "model": _vm.form,
	      "inline": true,
	      "label-position": _vm.labelPosition
	    }
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.deleteFormVisible = false
	      }
	    }
	  }, [_vm._v("No Way, Get Me Out Of Here!")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "danger"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteProject()
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.auth.user == null) ? _c('div', {
	    attrs: {
	      "id": "login-form"
	    }
	  }, [_c('el-form', {
	    ref: "loginForm",
	    staticClass: "loginForm",
	    attrs: {
	      "model": _vm.loginForm,
	      "rules": _vm.rules,
	      "label-position": _vm.labelPosition,
	      "label-width": "100px"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
	        _vm.submitForm('loginForm')
	      }
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.loginForm.email),
	      callback: function($$v) {
	        _vm.loginForm.email = $$v
	      },
	      expression: "loginForm.email"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Password",
	      "prop": "pass"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.loginForm.pass),
	      callback: function($$v) {
	        _vm.loginForm.pass = $$v
	      },
	      expression: "loginForm.pass"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.submitForm('loginForm')
	      }
	    }
	  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
	    staticClass: "alt-link",
	    attrs: {
	      "to": "reset"
	    }
	  }, [_vm._v("Reset Password")])], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "reset-form"
	    }
	  }, [_c('el-form', {
	    ref: "ruleForm",
	    staticClass: "ruleForm",
	    attrs: {
	      "model": _vm.ruleForm,
	      "rules": _vm.rules,
	      "label-position": _vm.labelPosition,
	      "label-width": "100px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.ruleForm.email),
	      callback: function($$v) {
	        _vm.ruleForm.email = $$v
	      },
	      expression: "ruleForm.email"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.submitForm('ruleForm')
	      }
	    }
	  }, [_vm._v("Reset password")]), _vm._v(" "), _c('router-link', {
	    staticClass: "alt-link",
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("Back to Login")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "headerWrapper"
	  }, [_c('header', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('el-menu', {
	    staticClass: "el-menu-header",
	    attrs: {
	      "theme": "dark",
	      "default-active": _vm.activeIndex,
	      "mode": "horizontal"
	    }
	  }, [_c('el-menu-item', {
	    staticClass: "home-link",
	    attrs: {
	      "index": "1"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/",
	      "exact": ""
	    }
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(327)
	    }
	  })])], 1), _vm._v(" "), (_vm.auth.user !== null) ? _c('el-menu-item', {
	    attrs: {
	      "index": "2"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/projects"
	    }
	  }, [_c('span', [_vm._v("Projects")])])], 1) : _vm._e(), _vm._v(" "), (_vm.auth.user !== null) ? _c('el-submenu', {
	    attrs: {
	      "index": "5"
	    }
	  }, [_c('template', {
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.auth.user.email))]), _vm._v(" "), (_vm.userMeta.isAdmin == true) ? _c('el-menu-item', {
	    attrs: {
	      "index": "5-1"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$router.push('/users')
	      }
	    }
	  }, [_vm._v("Manage Users")]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
	    attrs: {
	      "index": "5-2"
	    },
	    on: {
	      "click": function($event) {
	        _vm.logOut()
	      }
	    }
	  }, [_vm._v("Logout")])], 2) : _vm._e()], 1)], 1)])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.7c79d7f4225470c3b0f5.js